import Vue from "vue";

export const tagCatalog = Vue.observable({
  taName: "",
  categories: [],
  allTags: [],
  loaded: false,
  loadedKey: "",
});

let pending = null;
let pendingKey = "";

export function loadHcpTagCatalog(axios, ownerUserId) {
  const specified = arguments.length > 1;
  const owner = specified ? (ownerUserId && ownerUserId !== "NA" ? String(ownerUserId) : "") : null;
  const key = specified ? `owner:${owner}` : "self";
  if (tagCatalog.loaded && tagCatalog.loadedKey === key) return Promise.resolve(tagCatalog);
  if (pending && pendingKey === key) return pending;
  pendingKey = key;
  const params = specified ? { userId: owner } : {};
  pending = axios
    .get("/hcpTag/catalog", { params })
    .then(({ code, data }) => {
      if (pendingKey !== key) return tagCatalog;
      if (code === 200 && data) {
        tagCatalog.taName = data.taName || "";
        tagCatalog.categories = data.categories || [];
        tagCatalog.allTags = data.allTags || [];
      }
      tagCatalog.loaded = true;
      tagCatalog.loadedKey = key;
      pending = null;
      return tagCatalog;
    })
    .catch((error) => {
      if (pendingKey === key) {
        pending = null;
        tagCatalog.loaded = true;
        tagCatalog.loadedKey = key;
      }
      throw error;
    });
  return pending;
}

export function resolveHcpTags(ids = []) {
  const selected = new Set(ids || []);
  return tagCatalog.allTags.filter((item) => selected.has(item.id));
}

export function groupHcpTags(ids = []) {
  const selected = resolveHcpTags(ids);
  const groups = [];
  const indexMap = {};
  selected.forEach((tag) => {
    if (indexMap[tag.categoryId] == null) {
      indexMap[tag.categoryId] = groups.length;
      groups.push({
        id: tag.categoryId,
        name: tag.categoryName,
        values: [],
      });
    }
    groups[indexMap[tag.categoryId]].values.push(tag);
  });
  return groups;
}

export function hcpMatchesTagFilter(hcpTagIds, selectedTagIds) {
  const selected = selectedTagIds || [];
  if (!selected.length) return true;
  const groups = groupHcpTags(selected);
  if (!groups.length) return false;
  const owned = new Set(hcpTagIds || []);
  return groups.every((group) => group.values.some((tag) => owned.has(tag.id)));
}
